export interface GeoJsonStyleOptions {
  strokeColor?: string;
  color?: string;
  fillColor: string;
  weight?: number;
  opacity?: number;
  fillOpacity?: number;
  hoverWeight?: number;
  hoverFillOpacity?: number;
}

export const DEFAULT_GRID_BORDERS: GeoJsonStyleOptions = {
  color: '#31436b',
  fillColor: '#2c4c73',
  weight: 2,
  opacity: 1,
  fillOpacity: 0.3,
  hoverWeight: 3,
  hoverFillOpacity: 0.20,
};

export const SELECTED_GRID_BORDERS: GeoJsonStyleOptions = {
  color: '#1c2a47',
  fillColor: '#1c2a47',
  weight: (DEFAULT_GRID_BORDERS.weight ?? 2) + 2,
  opacity: 1,
  fillOpacity: 0.1,
  hoverWeight: 3,
  hoverFillOpacity: 0.20,
};

export const HOVER_GRID_BORDERS: GeoJsonStyleOptions = {
  color: '#4a5f8f',
  fillColor: '#4a5f8f',
  weight: 3,
  opacity: 1,
  fillOpacity: 0.2,
  hoverWeight: 3,
  hoverFillOpacity: 0.20,
};

export const ASSIGNED_GRID_BORDERS: GeoJsonStyleOptions = {
  color: '#e8871e',
  fillColor: '#e8871e',
  weight: (DEFAULT_GRID_BORDERS.weight ?? 2) + 2,
  opacity: 1,
  fillOpacity: 0.1,
  hoverWeight: 3,
  hoverFillOpacity: 0.20,
};
